import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { convertObjectKeysToSnakeCase } from "../../Shared/ConvertObjectKeysToSnakeCase";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const getInterests = ({
  onResponse,
  onError,
  pageNumber,
  debouncedInterestNameForFuzzyFilter,
}) => {
  let queryString = '';

  if (!!debouncedInterestNameForFuzzyFilter) {
    queryString = `?page_number=${pageNumber}&debounced_interest_name_for_fuzzy_filter=${debouncedInterestNameForFuzzyFilter}`;
  } else {
    queryString = `?page_number=${pageNumber}`;
  }

  fetch(
    `/api/interests${queryString}`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const createUnrecognizedInterest = ({
  body,
  onResponse,
  onError,
}) => {
  fetch(
    `/api/interests/create_unrecognized_interest`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const recognizeInterest = ({
  body,
  onResponse,
  onError,
}) => {
  fetch(
    `/api/interests/recognize_interest`,
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const disallowInterest = ({
  body,
  onResponse,
  onError,
}) => {
  fetch(
    `/api/interests/disallow_interest`,
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
